<template>
    <div class="gifPicker">
        <div class="gp-search">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" v-model="query" :placeholder="$t('dash.post-creator.media-editor.gif-picker.search-placeholder')" @click.stop>
        </div>

        <p class="gp-status" v-if="!apiKeyConfigured">{{ $t('dash.post-creator.media-editor.gif-picker.no-api-key') }}</p>
        <template v-else>
            <p class="gp-status" v-if="loading">{{ $t('dash.post-creator.media-editor.gif-picker.loading') }}</p>
            <p class="gp-status" v-else-if="error">{{ $t('dash.post-creator.media-editor.gif-picker.error') }}</p>
            <p class="gp-status" v-else-if="!results.length">{{ $t('dash.post-creator.media-editor.gif-picker.no-results') }}</p>
            <div class="gp-grid" v-else>
                <div
                    v-for="gif in results"
                    :key="gif.id"
                    class="gp-item"
                    :class="{ active: value === gif.gifUrl }"
                    @click="$emit('select', gif.gifUrl)"
                >
                    <img :src="gif.thumbnailUrl" :alt="gif.title" loading="lazy">
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { searchGifs } from '../engine/gifSearch.js'

const SEARCH_DEBOUNCE_MS = 400

export default {
    name: 'GifPicker',

    props: {
        value: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            query: '',
            results: [],
            loading: false,
            error: false,
            apiKeyConfigured: !!process.env.VUE_APP_GIPHY_API_KEY
        }
    },

    watch: {
        query() {
            clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(this.runSearch, SEARCH_DEBOUNCE_MS)
        }
    },

    mounted() {
        if (this.apiKeyConfigured) this.runSearch()
    },

    beforeDestroy() {
        clearTimeout(this.debounceTimer)
    },

    methods: {
        // An empty query resolves to Giphy's trending list (see searchGifs) - shown by default
        // on open and again any time the user clears their search.
        async runSearch() {
            const requestId = (this.latestRequestId = (this.latestRequestId || 0) + 1)
            this.loading = true
            this.error = false
            try {
                const results = await searchGifs(this.query)
                if (requestId !== this.latestRequestId) return // a newer search started meanwhile
                this.results = results
            } catch (e) {
                if (requestId !== this.latestRequestId) return
                this.error = true
                this.results = []
            } finally {
                if (requestId === this.latestRequestId) this.loading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
